/** platform 暂无 dictionary 接口时的静态兜底（与旧站 seed 对齐的常用项） */

export type StaticDictOption = { label: string; value: string }

export const STATIC_DICTIONARY_MAP: Record<string, StaticDictOption[]> = {
  type_format: [
    { label: '.stl', value: 'format1' },
    { label: '.stp', value: 'format2' },
    { label: '.obj/mtl', value: 'format3' },
    { label: '.fbx', value: 'format4' },
    { label: '.max', value: 'format5' },
    { label: '.ma/mb', value: 'format6' },
    { label: '.c4d', value: 'format7' },
    { label: '.blend', value: 'format8' },
    { label: '.usdz', value: 'format9' },
    { label: '.dwg', value: 'format10' },
    { label: '.ige/igs/iges', value: 'format11' },
    { label: '.3dm', value: 'format12' },
    { label: '.bip/ksp', value: 'format13' },
    { label: '.gltf/.glb', value: 'format14' },
    { label: '.ply', value: 'format15' },
    { label: '.dae', value: 'format16' },
    { label: '.3ds', value: 'format17' },
    { label: '.3mf', value: 'format18' },
    { label: '.usd', value: 'format19' },
    { label: '.abc', value: 'format20' },
    { label: '.x_t', value: 'format21' },
    { label: '.sldprt', value: 'format22' },
    { label: '.wrl', value: 'format23' },
    { label: '其他', value: 'format24' },
  ],
  type_area: [
    { label: '5k以下', value: 'area1' },
    { label: '5k-10k', value: 'area2' },
    { label: '10k-30k', value: 'area3' },
    { label: '30k-100k', value: 'area4' },
    { label: '100k以上', value: 'area5' },
  ],
  type_wiring: [
    { label: '三角形', value: 'wiring1' },
    { label: '四边形', value: 'wiring2' },
    { label: 'N角形', value: 'wiring3' },
    { label: '面片形', value: 'wiring4' },
    { label: '三角+四边形', value: 'wiring5' },
  ],
  type_uv: [
    { label: '未展开', value: 'uv1' },
    { label: '已展开,有重叠', value: 'uv2' },
    { label: '已展开,无重叠', value: 'uv3' },
    { label: '混合', value: 'uv4' },
  ],
  price_type: [
    { label: '免费', value: 'price_free' },
    { label: '个人授权', value: 'price_personal' },
    { label: '企业授权', value: 'price_company' },
    { label: '扩展授权', value: 'price_extend' },
  ],
  MODEL_ORDER_STATUS: [
    { label: '待支付', value: 'model_pendingPayment' },
    { label: '已购买', value: 'model_purchased' },
    { label: '已取消', value: 'model_canceled' },
    { label: '退款/售后', value: 'model_refund' },
  ],
  ORDER_STATUS: [
    { label: '待支付', value: 'PENDING_PAYMENT' },
    { label: '已支付', value: 'PAID' },
    { label: '生产中', value: 'PRODUCING' },
    { label: '已发货', value: 'SHIPPED' },
    { label: '已完成', value: 'RECEIVED' },
    { label: '已取消', value: 'CANCELED' },
    { label: '退款中', value: 'REFUND_APPLIED' },
    { label: '已退款', value: 'REFUNDED' },
  ],
  ORDER_TYPE: [
    { label: '3D模型', value: 'MODEL' },
    { label: '3D打印', value: 'PRINT' },
    { label: '3D扫描', value: 'SCAN' },
    { label: '3D设计', value: 'DESIGN' },
    { label: 'CNC加工', value: 'CNC' },
    { label: '其他', value: 'OTHER' },
  ],
  SCAN_ORDER_STATUS: [
    { label: '待支付', value: 'PENDING_PAYMENT' },
    { label: '已支付', value: 'PAID' },
    { label: '扫描中', value: 'SCANNING' },
    { label: '已发货', value: 'SHIPPED' },
    { label: '已完成', value: 'RECEIVED' },
    { label: '已取消', value: 'CANCELED' },
    { label: '已退款', value: 'REFUNDED' },
  ],
  MATERIAL_TYPE: [
    { label: '光敏树脂', value: 'RESIN' },
    { label: '高分子粉末', value: 'POLYMER_POWDER' },
    { label: '金属粉末', value: 'METAL_POWDER' },
    { label: '线材', value: 'WIRE' },
    { label: '陶瓷材料', value: 'CERAMIC' },
    { label: '尼龙', value: 'NYLON' },
    { label: '其他材料', value: 'OTHER' },
  ],
}
